export const SUBJECT_LIST_REQUEST = 'SUBJECT_LIST_REQUEST'
export const SUBJECT_LIST_SUCCESS = 'SUBJECT_LIST_SUCCESS'
export const SUBJECT_LIST_FAILURE = 'SUBJECT_LIST_FAILURE'

export const CREATE_SUBJECT_REQUEST = 'CREATE_SUBJECT_REQUEST'
export const CREATE_SUBJECT_SUCCESS = 'CREATE_SUBJECT_SUCCESS'
export const CREATE_SUBJECT_FAILURE = 'CREATE_SUBJECT_FAILURE'
